import React from 'react';
import PropTypes from 'prop-types';

const CombinedProvider = ({ children }) => {
    return <>{children}</>;
};

CombinedProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default CombinedProvider;
